export interface RouterStateData {
  [key: string]: any;
}


export interface RouterStateArgs {
  data: RouterStateData;
  initial: boolean;
  params: RouterStateData;
  path: string;
  queryParams: RouterStateData;
  url: string;
}


export class RouterState {
  readonly data: RouterStateData;
  readonly initial: boolean;
  readonly params: RouterStateData;
  readonly path: string;
  readonly queryParams: RouterStateData;
  readonly url: string;

  constructor(args: Partial<RouterStateArgs>) {
    Object.assign(this, {
      data: {},
      initial: false,
      params: {},
      path: '',
      queryParams: {},
      url: ''
    }, args);
  }
}
